import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PortalMixin',

  methods: {
    modalToggled(newHasContent: boolean): void {
      if (newHasContent && process.client) {
        document.body.classList.add('no-scroll')
      } else if (process.client) {
        document.body.classList.remove('no-scroll')
      }
    }
  }
})
